import { ReactNode } from 'react';
import { MediaGallerySlide } from '@ahc-digital/component-library';
import { useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { GetMediaGalleryItemModel } from './C43MediaGalleryItem.service';
import { C43MediaGalleryItemProps } from './C43MediaGalleryItem.types';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C43MediaGalleryItemProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource) {
    return <PromptForMissingDatasource rendering={props?.rendering} />;
  }

  const slideModel = GetMediaGalleryItemModel(props);

  if (isEditing) {
    const Field = ({ label, value }: { label: string; value: ReactNode }) => (
      <div style={{ display: 'grid', gap: '0.5rem' }}>
        <span>
          <b>{label}:</b>
        </span>
        {value}
      </div>
    );

    return (
      <div style={{ display: 'grid', gap: '1rem', paddingBlock: '2rem' }}>
        <Field label="Image" value={slideModel.image} />
        <Field label="Video ID" value={slideModel.videoIdField} />
        <Field label="Audio Source" value={slideModel.audioSrcField} />
        <Field label="Headline" value={slideModel.headline} />
        <Field label="Support copy" value={slideModel.supportCopy} />
      </div>
    );
  }

  return <MediaGallerySlide {...slideModel} data-component={marketingRenderingName} />;
};
